import { HttpInterceptorFn } from '@angular/common/http';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (typeof window === 'undefined') {
    return next(req);
  }

  const url = req.url;
  let token: string | null = null;

  if (url.includes('/admin/graphql')) {
    token = localStorage.getItem('auth_token');
  } else if (url.includes('/client/graphql')) {
    token = localStorage.getItem('client_auth_token');
  }

  if (token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  return next(req);
};
